module.exports = __webpack_public_path__ + "img/24.a0c7a52d.png";